/**
 * @file Contexte de devise pour la propagation automatique du multi-devise.
 * @module packages.common.contexts.currency-context.CurrencyContext
 *
 * `CurrencyProvider` lit la devise de la company active depuis le sessionStore
 * et met à jour le module-level default de `formatNumber.js`. Ainsi, tous les
 * appels existants à `fCurrency`/`eCurrency` sans paramètre utilisent
 * automatiquement la bonne devise sans modification des composants.
 */

import {useEffect} from 'react';
import useSessionStore from '../../stores/sessionStore';
import {_setDefaultCurrency} from '../../utils/formatNumber';

/**
 * Synchronise la devise par défaut des formatters avec la company active.
 *
 * Ce composant ne rend aucun élément visuel. Il se contente d'appeler
 * `_setDefaultCurrency` à chaque changement de `activeCompany.currency`.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @return {React.ReactNode}
 */
export function CurrencyProvider({children}) {
  const currency = useSessionStore((state) => state.activeCompany?.currency || 'EUR');

  useEffect(() => {
    _setDefaultCurrency(currency);
  }, [currency]);

  return children;
}
